import { render, staticRenderFns } from "./FMReferent.vue?vue&type=template&id=37d98ac6&scoped=true&"
import script from "./FMReferent.vue?vue&type=script&lang=js&"
export * from "./FMReferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d98ac6",
  null
  
)

export default component.exports